import { connect } from "react-redux"
import Modal from "../modal"
import React from "react";

const ModalGlobal = (props) => {
   const { modal } = props;
   const { isOpen, data } = modal;
   const children = data?.children;
   return (
      <React.Fragment>
         {isOpen &&
            <Modal>
               {children}
            </Modal>
         }
      </React.Fragment>
   )
}

const mapStateToProps = (state) => {
   const { modal } = state;
   return {
      modal
   }
}

export default connect(mapStateToProps, {})(ModalGlobal);